module.exports = __webpack_public_path__ + "img/icone-bebidas.dc70e5b8.svg";